import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import RemoveCircleRoundedIcon from "@mui/icons-material/RemoveCircleRounded";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import * as React from "react";

const CustomListForAutocomplete = React.forwardRef(
  function CustomListForAutocomplete(props: any, ref) {
    const {
      children: options,
      customProps: { handleClickIncluded, handleClickExcluded, handleEdit },
      ...other
    } = props;

    return (
      <List {...other} ref={ref}>
        {options.map((option: Record<string, any>, index: number) => {
          const {
            key,
            props: { onClick, ...optionProp },
            ...rest
          } = option;
          return (
            <ListItem key={index} {...optionProp}>
              <ListItemText primary={key} />
              <IconButton
                sx={{
                  fontSize: "22px",
                  "&:hover": {
                    backgroundColor: "inherit",
                    opacity: "0.7",
                  },
                }}
                onClick={(e) => {
                  handleClickIncluded(
                    e,
                    optionProp["data-option-index"],
                    onClick
                  );
                }}
              >
                <Tooltip title="Include">
                  <CheckCircleRoundedIcon fontSize="inherit" color="success" />
                </Tooltip>
              </IconButton>
              <IconButton
                sx={{
                  fontSize: "22px",
                  "&:hover": {
                    backgroundColor: "inherit",
                    opacity: "0.7",
                  },
                }}
                onClick={(e) => {
                  handleClickExcluded(
                    e,
                    optionProp["data-option-index"],
                    onClick
                  );
                }}
              >
                <Tooltip title="Exclude">
                  <RemoveCircleRoundedIcon color="error" fontSize="inherit" />
                </Tooltip>
              </IconButton>
              {handleEdit && (
                <IconButton
                  sx={{
                    fontSize: "22px",
                    "&:hover": {
                      backgroundColor: "inherit",
                      opacity: "0.7",
                    },
                  }}
                  onClick={(e) => {
                    handleEdit(e, optionProp["data-option-index"]);
                  }}
                >
                  <EditRoundedIcon fontSize="inherit" />{" "}
                </IconButton>
              )}
            </ListItem>
          );
        })}
      </List>
    );
  }
);

export default CustomListForAutocomplete;
